import { Longhand } from "../longhand.js";
import Base from "./top.js";
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/inset-inline-end}
 * @internal
 */
export default Longhand.extend(Base);
//# sourceMappingURL=inset-inline-end.js.map